import * as React from 'react';
import CardHeader from '@mui/material/CardHeader';
import AvatarGroup from '@mui/material/AvatarGroup';
import ImageAvatar from '../common/Avatar';

export default function AvatarGroupComp(props) {
  const avatarVals = props.pro;
  return (
    <CardHeader
      sx={{ padding: '0px' }}
      avatar={
        <AvatarGroup max={3} sx={{ justifyContent: 'left' }}>
          {avatarVals?.map((thumbnail) => (
            <ImageAvatar sx={{ height: '27px', width: '27px' }} alt="Travis Howard" src={thumbnail} />
          ))}
        </AvatarGroup>
      }
      title={props.txt}
      subheader={props.sub}
    />
  );
}
